<div class="background"></div>
<div class="main">
	<div class="logoHolder">
		<img class="logo" src="assets/common/logo@2x.png" alt="" />
	</div>
	<div class="mainHolder">
		<router-outlet></router-outlet>
	</div>
</div>
